import { Paper } from "@mui/material";
import { PaperProps } from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "tss-react/mui";

type MprcPaperClassParams =
    {
        borderColor?: MprcColorsExtended;
        paperColor?: MprcColorsExtended;
    };

const useStyles = makeStyles<MprcPaperClassParams>()(
    (theme, p, classes) => ({
        gutters: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            [theme.breakpoints.up('sm')]: {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3),
            },
        },

        normal: {
            padding: theme.spacing(2),
        },

        dense: {
            padding: theme.spacing(),
        },

        fullHeight: {
            height: "100%",
        },

        borderSquare: {
            borderRadius: "0",
        },

        borderRoundAccented: {
            borderRadius: "16px",
        },

        borderColor: {
            borderLeftWidth: "4px",
            borderLeftStyle: "solid",
            borderLeftColor: p.borderColor == null
                ? "unset"
                : p.borderColor == "white"
                    ? theme.palette.common.white
                    : p.borderColor == "black"
                        ? theme.palette.common.black
                        : p.borderColor == "inherit"
                            ? "inherit"
                            : p.borderColor == "transparent"
                                ? "transparent"
                                : theme.palette[p.borderColor!].main
        },

        paperColor: {
            backgroundColor: p.paperColor == null
                ? "unset"
                : p.paperColor == "white"
                    ? theme.palette.common.white
                    : p.paperColor == "black"
                        ? theme.palette.common.black
                        : p.paperColor == "inherit"
                            ? "inherit"
                            : p.paperColor == "transparent"
                                ? "transparent"
                                : theme.palette[p.paperColor!].main

        }
    })
);

interface IProps {
    dense?: boolean;
    disableGutters?: boolean;
    disablePadding?: boolean;
    fullHeight?: boolean;
    borderVariant?: "square" | "round" | "accentedRound";
    borderColor?: MprcColorsExtended;
    paperColor?: MprcColorsExtended;
}

type Props = IProps & PaperProps;

export const MprcPaper: React.FC<Props> = (props) => {

    const {
        elevation,
        borderColor,
        paperColor,
        children,
        dense = false,
        disableGutters = false,
        disablePadding = false,
        fullHeight = false,
        borderVariant = "round",
        ...rest
    } = props;
    const { classes, cx } = useStyles({ borderColor, paperColor });

    return (
        <Paper
            classes={
                {
                    root: cx(
                        {
                            [classes.paperColor]: paperColor != null,
                            [classes.borderColor]: borderColor != null,
                            [classes.gutters]: !disableGutters,
                            [classes.normal]: !dense && !disablePadding,
                            [classes.dense]: dense && !disablePadding,
                            [classes.fullHeight]: fullHeight,
                            [classes.borderRoundAccented]: borderVariant == "accentedRound",
                            [classes.borderSquare]: borderVariant == "square",
                        }
                    )
                }
            }
            elevation={fullHeight ? 0 : elevation}
            {...rest}
        >
            {children}
        </Paper>
    );
};
